'use es6';

import { hubletApi } from 'hub-http/middlewares/core';
import http, { noAuthClient } from '../../lib/utils/httpClient';
const API_CATALOG_PUBLIC_BASE = '/api/api-catalog-public/';
const PUBLIC_API_SPEC_BASE = '/public/api/spec/';
export function fetchSpecification(endpoint) {
  return http.get(`${API_CATALOG_PUBLIC_BASE}${endpoint}`, {
    query: {
      swaggerVersion: 3
    },
    // API_CATALOG_PUBLIC_BASE is only deployed to the na1 hublet
    api: hubletApi('app', 'hubspot', 'na1')
  });
}

// This is meant to call a new API, but doesn't utilize the set up tests
// TODO: update tests to utilize this new endpoint
export function fetchNewSpecification(endpoint) {
  const hostname = window.location.hostname;
  return http.get(`${PUBLIC_API_SPEC_BASE}${endpoint}`, {
    query: {
      swaggerVersion: 3
    },
    // hubspotqa.dev seems to not be recognized as an official "QA" domain.
    // TODO: Figure out why it's not recognized.
    api: hubletApi('api', hostname === 'hubspotqa.dev' ? 'hubspotqa' : 'hubspot', 'na1')
  });
}
export function fetchCustomSpecification(url, isInternal) {
  return isInternal ? http.get(url) : noAuthClient.get(url, {
    withCredentials: false
  });
}